import { container, Lifecycle } from 'tsyringe';
import { Cognito } from '../auth/cognito';
import { CognitoLocations } from '../auth/cognito-locations';
import { DiTokens } from './di-tokens';

export function registerDependencies() {
  container.register(DiTokens.CognitoLocations, { useClass: CognitoLocations }, { lifecycle: Lifecycle.Singleton });
  container.register(DiTokens.Cognito, { useClass: Cognito }, { lifecycle: Lifecycle.Singleton });
}
